import React, { useEffect, useMemo, useState } from "react";
import styles from "../../PagesStyles/AdminPurchaseEntryNew.module.css";
import AdminHeading from "../Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { useNavigate, useParams } from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  InvoiceEntryNewFields,
  OldGoldInvoiceEntryNewFields,
  PurchaseEntryFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import { useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import {
  convertInInvoiceWholeSaleFormat,
  getAllPaymentMethod,
  getCurrentFinancialYear,
  getInvoiceEditEntryFormData,
  getInvoiceEntryFormData,
  looseDiamondId,
  looseStoneId,
  selectStyle,
} from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import Select from "react-select";
import StoneSummary from "Components/AdminPurchaseEntryNew/StoneSummary";
import DiamondSummary from "Components/AdminPurchaseEntryNew/DiamondSummary";
import PaymentsEntryTable from "Components/AdminPurchaseEntryNew/PaymentsEntryTable";
import AmountSection from "Components/AdminPurchaseEntryNew/AmountSection";
import InvoiceSkuForm from "Components/AdminPurchaseEntryNew/InvoiceSkuForm";
import InvoiceWholeSaleSummary from "Components/AdminPurchaseEntryNew/InvoiceWholeSaleSummary";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import { Check, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import { a201, a714, a717, a729, a731 } from "Components/Api/RootApiPath";
import PageLoader from "Components/PageLoader";
import { fetchInvoiceList } from "services/invoiceServices";

const purchaseProductDefault = {
  StockKeepingUnit: "",
  ItemCode: "",
  MakingFixedAmt: 0,
  MakingPerGram: 0,
  MakingFixedWastage: 0,
  MakingPercentage: 0,
  MetalRate: 0,
  FinePercent: 0,
  WastagePercent: 0,
  Quantity: 1,
  PurityId: 0,
  CategoryId: 0,
  ProductId: 0,
  DesignId: 0,
  FineGoldWt: 0,
  FineSilverWt: 0,
  TotalFineGold: "",
  FineOtherMetalWt: 0,
  TotalStoneAmt: 0,
  TotalItemAmt: 0,
  FineWt: 0,
  WastageWt: 0,
  FineWastageWt: 0,
  RDPurchaseId: 0,
  CategoryName: "",
  ProductName: "",
  DesignName: "",
  GrossWt: 0,
  NetWt: 0,
  StoneWt: 0,
  Status: "Active",
  CounterId: 0,
  BranchId: 0,
  CompanyId: 0,
  FinePure: false,
  ClientCode: 0,
  AddToUnlabelled: false,
  MetalId: 0,
  MetalName: "",
  StoneName: "",
  StoneWeight: 0,
  StonePieces: 0,
  StoneRate: 0,
  StoneAmount: 0,
  HallmarkAmt: 0,
  TagWeight: 0,
  FindingWeight: 0,
  LanyardWeight: 0,
  Testing: "0",
  Stones: [],
  Diamonds: [],
  ConvertAmount: true,
  MRP: "0",
  ClipWeight: "0",
  ClipQuantity: "0",
  DiamondName: "",
  DiamondWeight: 0,
  DiamondRate: 0,
  DiamondPieces: 0,
  DiamondAmount: 0,
  DiamondSize: "0",
  DiamondPurchaseRate: "0",
  DiamondSellRate: "0",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondShape: "",
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondPurchaseAmount: "0",
  DiamondSellAmount: "0",
  DiamondDescription: "",
  status: "paid",
  skus: [],
  paymentTypes: [{ id: 1, mode: "Cash", amount: 1000, gold: 20, silver: 30 }],
  balanceGold: "",
  taxableAmount: "",
  gst: "",
  paidAmount: "",
  advanceAmount: "",
  balanceSilver: "",
  RODiscount: "",
  totalAmount: "",
  balanceAmount: "",
};

const AdminInvoiceEntryNew = ({ editStatus, defaultValues }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [active, setActive] = useState("AddNew");
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState();
  const [category, setCategory] = useState("");
  const [invoiceCreateLoading, setInvoiceCreateLoading] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const employeeFirstName = adminLoggedIn.FirstName;
  const employeeLastName = adminLoggedIn.LastName;
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);
  const apiService = new GetApiService(clientCode);

  const fetchData = async () => {
    try {
      const data = await apiService.fetchInvoiceCustomers();
      return data;
    } catch (e) {
      console.log(e);
    }
  };
  const {
    data: customerList,
    isLoading,
    isError,
    refetch: InvoiceRefetch,
  } = useQuery({
    queryKey: ["getAllcustomerList"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    staleTime: 1000 * 60 * 2,
  });
  const { data: InvoiceList } = useQuery({
    queryKey: ["getInvoicesList", clientCode],
    queryFn: fetchInvoiceList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const apifields = useMemo(
    () =>
      adminLoggedIn.Modules.filter(
        (module) => module.PageName === "invoice_entry"
      ),
    [adminLoggedIn]
  );
  const localfields = useMemo(() => toPlainFields(InvoiceEntryNewFields), []);
  const oldGoldLocalfields = useMemo(
    () => toPlainFields(OldGoldInvoiceEntryNewFields),
    []
  );
  const apifieldsControls = useMemo(
    () => apifields[0]?.PageControls || [],
    [apifields]
  );

  const [itemfields, setItemfields] = useState(() =>
    localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );

  const [oldGoldItems, setOldGoldItems] = useState(() =>
    oldGoldLocalfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );

  const [purchaseProduct, setPurchaseProduct] = useState(
    purchaseProductDefault
  );
  const [editValues, setEditValues] = useState();
  const [edit, setEdit] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });
  const specificField = watch("StockKeepingUnit");
  const skus = watch("skus");
  const paymentTypes = watch("paymentTypes");
  const inputPaymentMode = watch("inputPaymentMode");
  const invoiceNumber = watch("invoiceNumber");
  const TotalFineMetal = watch("TotalFineMetal");
  const gstCheckbox = watch("gstCheckbox");
  const customerName = watch("customerName");
  const TotalBillAmount = watch("TotalBillAmount");
  const TotalTaxableAmount = watch("TotalTaxableAmount");
  const TotalRODiscount = watch("TotalRODiscount");
  const AdvanceAmount = watch("advanceamount");
  const TotalPaidAmount = watch("TotalPaidAmount");

 console.log(customerName)
  useEffect(() => {
    const customer = customerList?.find(
      (customr) => customr?.Id == customerName?.value
    );
    if (customer?.Id) {
      setValue("TotalFineGold", customer?.FineGold);
      setValue("Mobile", customer?.Mobile);
      setValue("advanceamount", customer?.AdvanceAmount);
      setValue("balanceamount", customer?.BalanceAmount);
    }
  }, [customerList, customerName?.value]);

   useEffect(() => {
      // if (editStatus) {
        setIsSummaryOpen(true);
      // }
    }, [editStatus]);
  // useEffect(() => {
  //   if (invoiceNumber) {
  //     setValue("gstCheckbox", true);
  //   } else {
  //     setValue("gstCheckbox", false);
  //   }
  // }, [invoiceNumber]);

  useEffect(() => {
    setValue("gstCheckbox", true);
  }, [InvoiceList]);
  useEffect(() => {
    let financialYear = getCurrentFinancialYear()
    if(!editStatus){

      const list = gstCheckbox
      ? InvoiceList?.filter((item) => item?.BillType == "true")
      : InvoiceList?.filter((item) => item?.BillType == "false");
      if (list?.length) {
        let listItem =list[list.length - 1]
        let num = `${+listItem?.InvoiceCount + 1}/${financialYear}`

        setValue("invoiceNumber", num);
      } else {
        
        setValue("invoiceNumber", `1/${financialYear}`);
      }
    }
  }, [gstCheckbox, InvoiceList]);

  useEffect(() => {
    // if(TotalRODiscount){

    if (gstCheckbox && TotalTaxableAmount) {
      setValue(
        "TotalBillAmount",
        (
          +TotalTaxableAmount * 0.03 +
          +TotalTaxableAmount -
          +TotalRODiscount
        )?.toFixed(3)
      );
      setValue("TotalGst", (+TotalTaxableAmount * 0.03)?.toFixed(3));
    } else {
      setValue(
        "TotalBillAmount",
        ((+TotalTaxableAmount || 0) - (+TotalRODiscount || 0))?.toFixed(3)
      );
      setValue("TotalGst", "");
    }
    // }
  }, [TotalTaxableAmount, gstCheckbox, TotalRODiscount, skus]);

  useEffect(() => {
    let paidMetal = 0;
    let advanceAmount = 0;
    let balanceMetal = 0;
    let paidAmount = 0;
    console.log(paymentTypes);
    paymentTypes?.forEach((item) => {
      if (item?.status == "paid" && item?.mode == "Metal") {
        paidMetal += +item?.MetalFinePaid || 0;
      }
      if (item?.status == "advance") {
        advanceAmount += +item?.amount || 0;
      }
      if (
        item?.status == "paid" && 
        (item?.mode == "Cash" || item?.mode == "Metal to Cash")
      ) {
        paidAmount += (+item?.amount || +item?.MetalCashTotalAmount || 0);
        if (item?.MetalCashTotalAmount) {
          setValue(
            "TotalTaxableAmount",
            (
              +(TotalTaxableAmount || 0) - +(item?.MetalCashTotalAmount || 0)
            )?.toFixed(3)
          );
        }
      }
    });

    if (+TotalFineMetal) {
      balanceMetal = +TotalFineMetal - +paidMetal;
    } else {
      balanceMetal = 0 - +paidMetal;
    }

    setValue("TotalPaidMetal", (+paidMetal)?.toFixed(3));
    setValue("TotalBalanceMetal", (+balanceMetal)?.toFixed(3));
    console.log(advanceAmount)
    console.log(paidAmount)
    console.log(paymentTypes)
    setValue("TotalAdvanceAmount", (+advanceAmount)?.toFixed(3));
    setValue("TotalPaidAmount", (+paidAmount)?.toFixed(3));
  }, [paymentTypes, TotalFineMetal]);

  useEffect(() => {
    setValue(
      "TotalBalanceAmount",
      (+(TotalBillAmount || 0) - +(TotalPaidAmount || 0))?.toFixed(3)
    );
  }, [TotalBillAmount, TotalPaidAmount]);

  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData();
  };

  const addSku = (data, fromDropdown) => {
    console.log(data);
    const res = fromDropdown ? data : convertInInvoiceWholeSaleFormat(data);
    console.log(res);
    setValue("skus", [...skus, res]);
    setIsSummaryOpen(true);
  };

  const updateSku = (data) => {
    console.log(data);
    const res = convertInInvoiceWholeSaleFormat(data);
    console.log(res);
    setValue(
      "skus",
      skus.map((sku, index) => (index == res.index ? res : sku)) // Replace only the matching SKU
    );
    setEditValues();
    setEdit(false);
    setIsSummaryOpen(true);
  };
  const addPaymentMode = (data) => {
    setValue("paymentTypes", [
      ...paymentTypes,
      {
        // id: editStatus ? data?.id : Date.now(),
        ...data,
      },
    ]);
  };
  const onSubmit = async (data) => {
    // if (!skus.length) {
    //   toast.error("Atleast one item needed");
    //   return
    // }
    const formData = editStatus ? getInvoiceEditEntryFormData({
      data,
      customerList,
      clientCode,
      invoiceDate,
      CompanyId,
      CounterId,
      BranchId,
      EmployeeId,
      employeeFirstName,
      employeeLastName,
    }): getInvoiceEntryFormData({
      data,
      customerList,
      clientCode,
      invoiceDate,
      CompanyId,
      CounterId,
      BranchId,
      EmployeeId,
      employeeFirstName,
      employeeLastName,
    });
    setInvoiceCreateLoading(true);

    console.log(data);
    console.log(formData);
    if (editStatus) {
      try {
         const response = await fetch(a731, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(formData),
                });
                const jsondata = await response.json();
                console.log(jsondata);
                // if (jsondata?.Id) {
                //   await sendProductData(jsondata?.Id, data);
                // }
      } catch (error) {
       
        toast.error(error?.message || "Failed to update invoice information.");
      }finally{
        setInvoiceCreateLoading(false);
      }
    } else {
      try {
        const response = await fetch(a729, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const rcvdData = await response.json();
        if (rcvdData?.Status == 400) {
          throw new Error("Failed to create invoice");
        } else {
          toast.success(
            `Invoice has been ${
              editStatus ? "updated" : "created"
            } successfully.`
          );
          if (editStatus) {
            navigate("/invoice_entries_list");
          } else {
            InvoiceRefetch();
            setTimeout(() => {
              navigate("/invoice_entry_new");
            }, 2000);
          }
          console.log(rcvdData);
        }
      } catch (error) {
        console.log("error");
        toast.error(`${error?.message || "Failed to create invoice"}`);
      } finally {
        setInvoiceCreateLoading(false);
      }
    }
  };

  const handleReset = () => {
    if (editStatus && id) {
      navigate(`/edit_invoice_entry_new/${id}`);
    } else {
      // RDPurchaseRefetch();
      navigate("/invoice_entry_new");
    }
  };
  return (
    <>
      <div>
        <AdminHeading />
        {/* {invoiceCreateLoading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <PageLoader />
          </div>
        ) : ( */}
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={reloadData} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        {/* )} */}

        <AdminBreadCrump
          title={`${editStatus ? "Update Invoice Entry" : "Add Invoice Entry"}`}
          companyName={"Loyalstring"}
          module={"Transactions"}
          page={`${editStatus ? "Update Invoice Entry" : "Add Invoice Entry"}`}
        />
      </div>

      <form className={styles.mainbox}>
        {/*basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            <div className={styles.box}>
              <label>Invoice No</label>
              <input {...register("invoiceNumber")} 
              disabled={true}
              />

              {/*  */}
            </div>

            <div className={styles.dateSection}>
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "start",

                  gap: "5px",
                  flexDirection: "column",
                }}
              >
                <label htmlFor="invoiceDate">Purchase Amount</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    type="text"
                    value={1300}
                    disabled={true}
                    {...register("PurchaseAmount")}
                    style={{
                      padding: "5px 0px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "none",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      fontSize: "16px",
                      fontWeight: "bolder",
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "start",

                  gap: "5px",
                  flexDirection: "column",
                }}
              >
                <label htmlFor="invoiceDate">Profit Amount</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    type="text"
                    value={1300}
                    disabled={true}
                    {...register("ProfitAmount")}
                    style={{
                      padding: "5px 0px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "none",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      fontWeight: "bolder",
                      fontSize: "16px",
                    }}
                  />
                </div>
              </div> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  gap: "5px",
                  flexDirection: "column",
                }}
              >
                <label htmlFor="invoiceDate">Date</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    id="invoiceDate"
                    type="date"
                    {...register("invoiceDate")}
                    style={{
                      width: "100%",
                      padding: "5px 10px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* top section */}

        <div className={styles.linesection}>
          <div className={styles.container}>
            {itemfields
              ?.filter((field) => field?.place === "top" && field.IsVisible)
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <div className={styles.box}>
                  <label>
                    {field.label}
                    {field?.mandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </label>
                  {field.type === "inputselect" ? (
                    // SKU Input with datalist
                    <input
                      type="text"
                      name={field.key}
                      placeholder={`${field.label}`}
                      disabled={field.visibility === "ReadOnly"}
                      {...register(field.key, {
                        required:
                          field?.mandatory &&
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                      })}
                      list="skuList"
                      autoComplete="off"
                      style={{ border: "1px solid #ddd" }}
                    />
                  ) : field.type === "dropdown" ||
                    field.type === "searchDropdown" ? (
                    <Controller
                      name={field.key}
                      control={control}
                      rules={{
                        required:
                          field?.mandatory &&
                          field.visibility !== "ReadOnly" &&
                          `${field.label} is required`,
                      }}
                      render={({
                        field: controllerField,
                        // fieldState: { error },
                      }) => (
                        <Select
                          {...controllerField}
                          options={
                            field.key === "customerName"
                              ? Array.isArray(customerList)
                                ? customerList?.map((vendor) => ({
                                    value: vendor?.Id,
                                    label: vendor?.FirstName + vendor?.LastName,
                                  }))
                                : []
                              : []
                          }
                          isDisabled={field.visibility === "ReadOnly"}
                          isSearchable={field.type === "searchDropdown"}
                          placeholder="-- select --"
                          styles={selectStyle}
                        />
                      )}
                    />
                  ) : field.type === "number" || field.type === "text" ? (
                    // Number input field
                    <input
                      name={field.key}
                      type={field.type}
                      placeholder={`${field.label}`}
                      {...register(field.key, {
                        required:
                          field.visibility !== "ReadOnly" &&
                          field?.mandatory &&
                          `${field.label} is required`,
                        pattern: field.type === "number" ? /^\d+$/ : undefined,
                      })}
                      style={{ border: "1px solid #ddd" }}
                      disabled={field.visibility === "ReadOnly"}
                    />
                  ) : null}
                  {errors[field.key] && (
                    <span className={styles.fielderror}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        {isSummaryOpen ? (
          <div className={styles.summarySection}>
            <>
              {skus[0]?.CategoryId?.value != looseStoneId &&
              skus[0]?.CategoryId?.value != looseDiamondId ? (
                <InvoiceWholeSaleSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  addSku={addSku}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus?.length && skus[0]?.CategoryId?.value == looseStoneId ? (
                <StoneSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus?.length &&
                skus[0]?.CategoryId?.value == looseDiamondId ? (
                <DiamondSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : (
                ""
              )}
            </>
          </div>
        ) : (
          <>
            {/* middle section */}

            <InvoiceSkuForm
              isInvoiceEntry={true}
              itemfields={itemfields}
              oldGoldLocalfields={oldGoldLocalfields}
              editValues={editValues}
              edit={edit}
              updateSku={updateSku}
              addSku={addSku}
              isSummaryOpen={isSummaryOpen}
              setIsSummaryOpen={setIsSummaryOpen}
              skus={skus}
              apifields={apifields}
              setItemfields={setItemfields}
              setCategory={setCategory}
              VendorName={customerName}
            />

          </>
        )}

        {/* bottom section */}
        <div className={styles.linesection}>
          {/* calculations section */}
          <div className={styles.calculation}>
            {/* Left Section */}
            <div className={styles.calculationleft}>
              <PaymentModeForm
                addPaymentMode={addPaymentMode}
                invoiceNumber={invoiceNumber}
                AdvanceAmount={AdvanceAmount}
                editStatus={editStatus}
             />

              <div className={styles.tableContainer}>
                <PaymentsEntryTable
                  styles={styles}
                  paymentTypes={paymentTypes}
                  setValue={setValue}
                />
              </div>
            </div>

            {/* Right Section */}
            <AmountSection styles={styles} register={register} invoice={true} />
          </div>
          {/* {errors.status && (
            <p className={styles.error}>{errors.status.message}</p>
          )} */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "10px",
          }}
        >
          <button
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto", // Allows buttons to shrink proportionally
              minWidth: "100px", // Minimum button width
              maxWidth: "150px", // Prevents overly wide buttons
            }}
            type="button"
            onClick={handleSubmit(onSubmit)}
            disabled={invoiceCreateLoading}
          >
            {invoiceCreateLoading ? <Spinner /> : <Check size={20} />}{" "}
            {/* Adjusted icon size */}
            Save
          </button>

          <button
            type="button"
            onClick={handleReset}
            style={{
              background: "#fff",
              fontSize: "12px", // Smaller font size for responsiveness
              color: "#0077D4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid #0077D4",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Refresh size={20} /> {/* Adjusted icon size */}
            Reset
          </button>

          <button
            onClick={() => {
              navigate(`/invoice_entries_list`);
            }}
            type="button"
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
            {/* Adjusted icon size */}
            Invoice List
          </button>
        </div>
      </form>
    </>
  );
};

export default AdminInvoiceEntryNew;
